module.exports = __webpack_public_path__ + "static/media/theme-user.20341b54.svg";